export default __webpack_public_path__ + "static/book-bb5bb5a22e6e5f6ef7e389b1eb8d03c1.png";